import zod from 'zod';

// const options = zod.enum([...Permissions.options]);

export const RoleFormSchema = zod.object({
  id: zod.number().optional(),
  name: zod.string(),
  hexadecimalColor: zod.string(),
  permissions: zod.array(zod.string()),
});
